'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const{DataSet:DataSet,Timeline:Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const{ScheduleRowDirectiveController:ScheduleRowDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ScheduleRowAxisDirective=function(_BaseControllerBacked){_inherits(ScheduleRowAxisDirective,_BaseControllerBacked);function ScheduleRowAxisDirective(){_classCallCheck(this,ScheduleRowAxisDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ScheduleRowAxisDirective,[{key:'template',get:function()
{return''}},{key:'objectBindings',get:function()

{return['axisBounds','freshSearch']}},{key:'$inject',get:function()

{return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}},{key:'controller',get:function()

{return ScheduleRowAxisController}}]);return ScheduleRowAxisDirective}(BaseControllerBackedDirective);






const ENABLE_TIMELINE_SCROLLING=!0;let

ScheduleRowAxisController=function(_ScheduleRowDirective){_inherits(ScheduleRowAxisController,_ScheduleRowDirective);
function ScheduleRowAxisController($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){_classCallCheck(this,ScheduleRowAxisController);var _this2=_possibleConstructorReturn(this,
_ScheduleRowDirective.call(this,$scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService));

_this2._scheduleRowScrollingService.setAxis(_this2);

_this2._horizontalThrottleSpeedMs=41;
_this2._animationTimeMs=0;

_this2._$scope.$evalAsync(function(){return _this2._redraw()});return _this2;
}ScheduleRowAxisController.prototype.

_setupWatchers=function _setupWatchers(){var _this3=this;
this._$scope.$watch('controller.axisBounds',function(newAxisBounds,oldAxisBounds){
if(!_this3.freshSearch&&_.isEqual(oldAxisBounds,newAxisBounds)){
return;
}
_this3._visibleBoundsOverride=null;
if(_this3._timeline){
_this3._timeline.setOptions({min:newAxisBounds.start,max:newAxisBounds.end});
}

const{defaultWindowSizeInMilliseconds:defaultWindowSizeInMilliseconds}=_this3._scheduleRowScrollingService;
const visibleBoundsEnd=newAxisBounds.end.getTime()-newAxisBounds.start.getTime()>defaultWindowSizeInMilliseconds?
new Date(newAxisBounds.start.getTime()+defaultWindowSizeInMilliseconds):
newAxisBounds.end;

_this3.__updateAxisWindowAndAllScheduleWindows({start:newAxisBounds.start,end:visibleBoundsEnd},0);
_this3._updateWindow();
_this3.freshSearch=!1;
});
this._$scope.$on('$destroy',function(){return _this3._scheduleRowScrollingService.setAxis(null)});
};ScheduleRowAxisController.prototype.

_setupTimeline=function _setupTimeline(){var _this4=this;

const zoomable=this._scheduleRowScrollingService.maxWindowSizeInMilliseconds!==this._scheduleRowScrollingService.minWindowSizeInMilliseconds;

this._timeline=new Timeline(this._container[0],this._dataset,_.defaults({
moment:this._momentWithTimeZoneForTimeline,
format:{
minorLabels:function(date,scale,step){
return[
Formatters.dayOfWeekInTimeZone(date,_this4._timeZoneService.localTimeZone).toUpperCase(),
Formatters.monthAndDayInTimeZone(date,_this4._timeZoneService.localTimeZone,{dayFirst:!0})].
join('<br/>');
}},

showMinorLabels:!0,
onInitialDrawComplete:function(){return _this4._initialDrawComplete=!0},
moveable:ENABLE_TIMELINE_SCROLLING,
zoomable:zoomable,
zoomMax:this._scheduleRowScrollingService.maxWindowSizeInMilliseconds,
zoomMin:this._scheduleRowScrollingService.minWindowSizeInMilliseconds,
min:this.axisBounds.start,
max:this.axisBounds.end,
start:this.currentBounds.start,
end:this.currentBounds.end},
ScheduleRowDirectiveController.DefaultTimelineOptions));






const throttledRangeChanger=_.throttle(function(newBounds){return _this4.__updateAxisWindowAndAllScheduleWindows(newBounds,_this4._animationTimeMs)},this._horizontalThrottleSpeedMs);

this._timeline.on('rangechange',function(obj){
if(!obj.byUser){
return;
}

throttledRangeChanger(obj);
});

this._timeline.on('rangechanged',function(_ref){let{start:start,end:end,byUser:byUser}=_ref;
if(!byUser){
return;
}

_this4.__updateAxisWindowAndAllScheduleWindows({start:start,end:end},0);
});
};ScheduleRowAxisController.prototype.

__updateAxisWindowAndAllScheduleWindows=function __updateAxisWindowAndAllScheduleWindows(_ref2,animationTimeMs){let{start:start,end:end}=_ref2;
if(this._visibleBoundsOverride&&
this._visibleBoundsOverride.start.getTime()===start.getTime()&&
this._visibleBoundsOverride.end.getTime()===end.getTime()){
return;
}

this._visibleBoundsOverride={start:start,end:end};
this._scheduleRowScrollingService.updateScheduleWindows(animationTimeMs);
};_createClass(ScheduleRowAxisController,[{key:'currentBounds',get:function()

{
return this._visibleBoundsOverride||this.axisBounds;
}}]);return ScheduleRowAxisController}(ScheduleRowDirectiveController);


module.exports=ScheduleRowAxisDirective;
module.exports.ScheduleRowAxisDirectiveController=ScheduleRowAxisController;
//# sourceMappingURL=scheduleRowAxisDirective.js.map
